module.exports = __webpack_public_path__ + "img/712.677b5186.png";